import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/missions/mission-label.html";

import "Styles/components/mission-label.scss";

class MissionLabel
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.missionLabel = options.missionLabel;
    this.selected = false;
    this.visible = false;
  }

  get missionLabel()
  {
    return this._missionLabel;
  }

  set missionLabel(missionLabel)
  {
    this._missionLabel = missionLabel;
    this.updateMissionLabel();
  }

  static setUpMissionLabel(options)
  {
    let instance = new MissionLabel(options);
    instance.render();
    if(options.selected)
    {
      instance.toggleSelected();
    }
    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {

    let that = this;
    this.$element.on("click", function(e)
    {
      that.toggleSelected();
    });
  }

  toggleSelected()
  {
    if(this.$element.hasClass("selected"))
    {
      this.selected = false;
      this.$element.removeClass("selected");
    }
    else
    {
      this.selected = true;
      this.$element.addClass("selected");
    }

  }

  toggleVisible()
  {
    if(this.visible)
    {
      this.setVisibility(false);
    }
    else
    {
      this.setVisibility(true);
    }
  }

  setVisibility(visibility)
  {
    if(visibility)
    {
      this.visible = true;
      this.$element.show();
    }
    else
    {
      this.visible = false;
      this.$element.hide();
    }
  }


  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateMissionLabel();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateMissionLabel() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $missionLabelName = this.$element.find("[data-bind-target='mission-label-name']");
      $missionLabelName.empty();

      if (utils.isNotNull(this.missionLabel) && utils.isNotNull(this.missionLabel.missionLabelName)) {
        $missionLabelName.text(this.missionLabel.missionLabelName);
      }
    }
  }

}

export default MissionLabel;



// WEBPACK FOOTER //
// ./app/js/components/mission-label.js